import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadEffect } from "../../effect";
import { fitImageToContainer, safeListen, canvasToBlob } from "../../helpers/elements";

var Flip = /*#__PURE__*/function (_UpploadEffect) {
  _inherits(Flip, _UpploadEffect);

  var _super = _createSuper(Flip);

  function Flip() {
    var _this;

    _classCallCheck(this, Flip);

    _this = _super.apply(this, arguments);
    _this.name = "flip";
    _this.originalfileURL = "";
    _this.originalFile = {
      blob: new Blob()
    };
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M153 0v256h103L153 0zM0 256h103V0L0 256z\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>";
    _this.canvas = document.createElement("canvas");

    _this.template = function (_ref) {
      var file = _ref.file,
          translate = _ref.translate;
      var image = URL.createObjectURL(file.blob);
      _this.originalfileURL = image;
      _this.originalFile = file;
      return "\n      <div class=\"uppload-flip\">\n        <img style=\"width: 20px\" alt=\"\" src=\"".concat(image, "\">\n      </div>\n      <div class=\"settings\">\n        <button class=\"flip-btn-horizontal\">").concat(translate("effects.flip.buttons.horizontal"), "</button>\n        <button class=\"flip-btn-vertical\">").concat(translate("effects.flip.buttons.vertical"), "</button>\n      </div>\n    ");
    };

    _this.handlers = function (params) {
      var img = params.uppload.container.querySelector(".uppload-flip img");

      if (img) {
        fitImageToContainer(params, img).then(function () {
          var horizontal = params.uppload.container.querySelector(".settings button.flip-btn-horizontal");
          if (horizontal) safeListen(horizontal, "click", _this.update.bind(_assertThisInitialized(_this), params, true, false));
          var vertical = params.uppload.container.querySelector(".settings button.flip-btn-vertical");
          if (vertical) safeListen(vertical, "click", _this.update.bind(_assertThisInitialized(_this), params, false, true));
        });
      }
    };

    return _this;
  }

  _createClass(Flip, [{
    key: "imageToCanvasBlob",
    value: function imageToCanvasBlob(params) {
      var _this2 = this;

      var flipH = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var flipV = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return new Promise(function (resolve) {
        params.uppload.emitter.emit("processing");
        var scaleH = flipH ? -1 : 1;
        var scaleV = flipV ? -1 : 1;
        _this2.canvas = document.createElement("canvas");
        var image = document.createElement("img");
        image.src = _this2.originalfileURL;

        image.onload = function () {
          _this2.canvas.width = image.width;
          _this2.canvas.height = image.height;
          var posX = flipH ? image.width * -1 : 0;
          var posY = flipV ? image.height * -1 : 0;

          var context = _this2.canvas.getContext("2d");

          if (!context) return;
          context.clearRect(0, 0, _this2.canvas.width, _this2.canvas.height);
          context.scale(scaleH, scaleV);
          context.drawImage(image, posX, posY);
          canvasToBlob(_this2.canvas).then(function (blob) {
            var image = URL.createObjectURL(blob);
            _this2.originalfileURL = image;
            params.uppload.emitter.emit("process");
            return resolve(blob);
          });
        };
      });
    }
  }, {
    key: "update",
    value: function update(params, x, y) {
      var _this3 = this;

      var img = params.uppload.container.querySelector(".uppload-flip img");
      if (!img) return;
      this.imageToCanvasBlob(params, x, y).then(function (blob) {
        if (!blob) return;
        var file = _this3.originalFile;
        file.blob = blob;
        params.next(file);
        var image = URL.createObjectURL(blob);
        img.setAttribute("src", image);
      });
    }
  }]);

  return Flip;
}(UpploadEffect);

export { Flip as default };